import styled from 'styled-components';
import Panel from 'react-bootstrap/lib/Panel';
import ds, { media } from 'designsystem';

const StyledPanelBody = styled(Panel.Body)`
    margin-bottom: ${ds.get('metrics.s')};
    color: ${ds.brand('text')};
    font-size: ${ds.fs('base')};
    font-family: ${ds.get('type.fontFamily.text')};
    font-weight: ${ds.get('type.fontWeight.light')};
    line-height: ${ds.get('type.lineHeight.s')};
    display: flex;
    flex-direction: column;
    ${media.desktop`flex-direction: row`}
`;

export default StyledPanelBody;



// WEBPACK FOOTER //
// ./src/blocks/PanelGroup/StyledPanelBody.jsx